<div class="browse-state-page-container">
  <div class="combined-header">
    <public-header [providerPracticeState]="selectedStateAbbrev"></public-header>
    <div class="browse-by-selected-state">
      <h1 id="header-title" class="find-a-provider" data-test="find-a-provider-header">
        Find a Provider {{ selectedState ? 'in ' + selectedState : '' }}
      </h1>
    </div>
  </div>

  <main>
    <div class="scrollable-area">
      <div *ngIf="selectedState" class="browse-all-providers">
        <div>
          <a
            class="iris-button-text-responsive"
            [routerLink]="[
              '/',
              uriPrefix.STATE + '-' + selectedStateAbbrev.toLocaleLowerCase(),
              uriPrefix.CITY + '-' + emptyURIValue
            ]"
            [attr.aria-label]="'Show all providers in ' + selectedState"
          >
            Show all providers in {{ selectedState }}
          </a>
        </div>
        <div>
          <a
            class="iris-button-text-responsive"
            [routerLink]="'/browse'"
            aria-label="Show all states"
          >
            Show all states
          </a>
        </div>
      </div>

      <div class="filter-section">
        <div class="filter-category" *ngIf="insurances?.length > 0">
          <h3>By accepted insurance</h3>
          <ul>
            <li *ngFor="let insurance of insurances">
              <a
                class="subtitle"
                [routerLink]="[
                  '/',
                  uriPrefix.STATE + '-' + selectedStateAbbrev.toLocaleLowerCase(),
                  uriPrefix.CITY + '-' + emptyURIValue,
                  uriPrefix.INSURANCE + '-' + insurance.uriSafeValue
                ]"
              >
                {{ insurance.value }}
              </a>
            </li>
          </ul>
        </div>

        <div class="filter-category" *ngIf="specialities?.length > 0">
          <h3>By speciality</h3>
          <ul>
            <li *ngFor="let speciality of specialities">
              <a
                class="subtitle"
                [routerLink]="[
                  '/',
                  uriPrefix.STATE + '-' + selectedStateAbbrev.toLocaleLowerCase(),
                  uriPrefix.CITY + '-' + emptyURIValue,
                  uriPrefix.SPECIALTY + '-' + speciality.uriSafeValue
                ]"
              >
                {{ speciality.value }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </main>

  <public-footer></public-footer>
</div>
